const route = "/cycles";

const getActiveCycle = `${route}/active`;

export { route, getActiveCycle };
